import React from 'react';
import InvestmentSplashImage from '../../../../components/icons/InvestmentSplashImage';
import Button from '../../../../components/button/Button';
import {
    BalancesIcon,
    GrowthIcon,
    SecureIcon
} from '../../../../components/icons/TreasurySplashScreenImage';

const SplashStep1 = ({ onContinue }: { onContinue: () => void }) => {
    
    return (
        <>
            <InvestmentSplashImage />
            <h1 className='text-deepMidnightBlue text-[20px]  mb-2 text-center '>
                Invest Smarter, Right Within <br />
                <span className='font-semibold'>Frontedge</span>
            </h1>
            <div className='w-[360px] my-4 p-6 border-gray rounded-2xl border space-y-4'>
                <div className='flex items-center gap-2'>
                    <GrowthIcon />
                    <p className='text-midnightHaze text-sm'>
                        Unlock Growth for Your Idle Capital{' '}
                    </p>
                </div>
                <div className='flex items-center gap-2'>
                    <SecureIcon />
                    <p className='text-midnightHaze text-sm'>Powered by ARM </p>
                </div>
                <div className='flex items-center gap-2'>
                    <BalancesIcon />
                    <p className='text-midnightHaze text-sm'>
                        Manage Your Portfolio with Ease{' '}
                    </p>
                </div>
            </div>
            <p className='text-deepMidnightBlue text-sm text-center '>
                By continuing, you agree to Frontedge’s privacy policy and
                recieving updates on Frontedge.io
            </p>
            <Button
                onClick={onContinue}
                text={'Start Investing'}
                className='w-full'
            />
        </>
    );
};

export default SplashStep1;
